export enum Roles {
    // Sitrack Roles
    STK_ADMINISTRATION = "STK_ADMINISTRATION",
    STK_MEMBER = "STK_MEMBER",

    // Spook Roles
    SPOOK_ADMINISTRATION = "SPOOK_ADMINISTRATION",
    SPOOK_MEMBER = "SPOOK_MEMBER",
}

export const ONLY_STK = [
    Roles.STK_ADMINISTRATION,
    Roles.STK_MEMBER
];

export const ONLY_ADMINS = [
    Roles.STK_ADMINISTRATION,
    Roles.SPOOK_ADMINISTRATION
]

export const SecurityExpressions = {
    ONLY_STK,
    ONLY_ADMINS
}